export default __webpack_public_path__ + "static/media/gaming.93d0048f.png";